"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mastercard = _interopRequireDefault(require("payment-icons/min/single/mastercard.svg"));

var _visa = _interopRequireDefault(require("payment-icons/min/single/visa.svg"));

var _amex = _interopRequireDefault(require("payment-icons/min/single/amex.svg"));

var _discover = _interopRequireDefault(require("payment-icons/min/single/discover.svg"));

var _jcb = _interopRequireDefault(require("payment-icons/min/single/jcb.svg"));

var _diners = _interopRequireDefault(require("payment-icons/min/single/diners.svg"));

var _CreditCardIcons = require("./CreditCardIcons.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * CC Logo component
 */
// intentionally left as a functional component
var CreditCardIcons = function CreditCardIcons(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      disabled = _ref.disabled,
      mobile = _ref.mobile,
      props = _objectWithoutProperties(_ref, ["className", "dataTestId", "disabled", "mobile"]);

  return /*#__PURE__*/_react.default.createElement(_CreditCardIcons.StyledCreditCardIcons, _extends({}, props, {
    className: className,
    "data-test-id": dataTestId
  }), /*#__PURE__*/_react.default.createElement(_CreditCardIcons.ThinLineccWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditCardIcons.CardImage, {
    src: _visa.default,
    alt: "Visa"
  })), /*#__PURE__*/_react.default.createElement(_CreditCardIcons.ThinLineccWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditCardIcons.CardImage, {
    src: _mastercard.default,
    alt: "Mastercard"
  })), /*#__PURE__*/_react.default.createElement(_CreditCardIcons.ThinLineccWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditCardIcons.CardImage, {
    src: _amex.default,
    alt: "Visa"
  })), /*#__PURE__*/_react.default.createElement(_CreditCardIcons.ThinLineccWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditCardIcons.CardImage, {
    src: _discover.default,
    alt: "Discover"
  })), /*#__PURE__*/_react.default.createElement(_CreditCardIcons.ThinLineccWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditCardIcons.CardImage, {
    src: _jcb.default,
    alt: "JCB"
  })), /*#__PURE__*/_react.default.createElement(_CreditCardIcons.ThinLineccWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditCardIcons.CardImage, {
    src: _diners.default,
    alt: "Diners Club"
  })));
};

CreditCardIcons.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** disabling flag modifies visibility and click-ability */
  disabled: _propTypes.default.bool,

  /** mobile flag - renders a smaller image */
  mobile: _propTypes.default.bool
};
CreditCardIcons.defaultProps = {
  className: '',
  disabled: false,
  mobile: false
};
var _default = CreditCardIcons;
exports.default = _default;